export enum ColorStyle {
  Light,
  Dark,
}
